// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"48cb82c2","181":"8803c00c","453":"782296d0"}[chunkId] + ".chunk.js";
};